// The ClubHome component displays a club's homepage with various sections. It includes a main image section with an image
//  and a "Join Now" button, which is styled with Tailwind CSS. Below that, it presents a content section showcasing the
//  club's name and description. The component also renders a list of benefits, displaying each benefit with an image
//  and description. If no benefits are available, it shows a message stating "No benefits available." This component
//  uses props to receive content and benefit data, making it dynamic and reusable for different clubs.

import Button from 'components/commercetools-ui/atoms/button';
import React from 'react';
import { Benefit, ClubHomeType } from 'types/next';

interface ClubHomeProps {
  agContent: ClubHomeType;
}
const ClubHome = ({ agContent }: ClubHomeProps) => {
  return (
    <>
      <div className="main-image mb-[30px] flex flex-col items-center gap-y-8 bg-[#f8f8f8] p-50">
        <div className="mb-[30px] h-[213px] w-[355px] rounded-3xl bg-white shadow-2xl md:h-[285px] md:w-[490px]">
          <div className="h-[157px] w-[300px] px-96 py-64">
            <img
              src={agContent?.image}
              alt={agContent?.imageText}
              className="mx-[48px] h-[85px] w-[65px] md:mx-[90px] md:h-[157px] md:w-[120px]"
            />
          </div>
        </div>

        <h2 className="mb-[30px] text-46 font-extrabold text-[#242d58]">{agContent?.imageText}</h2>
        <Button className="h-40 w-[250px] rounded-sm px-16 py-9 text-20 font-bold" variant="primary">
          JOIN NOW
        </Button>
      </div>
      <div className="content mb-[30px] flex flex-col items-center p-16">
        <h2 className="mb-10 text-32 font-bold">{agContent?.content?.name.toLocaleUpperCase()}</h2>
        <p className="mx-auto max-w-4xl text-center text-17 font-normal leading-6 tracking-wide">
          {agContent?.content?.description}
        </p>
      </div>
      <div className="club-benefits-container flex flex-col items-center justify-center p-16">
        <h3 className="mb-[30px] text-32 font-bold">BENEFITS</h3>
        <div className="club-benefits-tile flex flex-wrap justify-center gap-x-20">
          {agContent?.benefits?.length > 0 ? (
            agContent.benefits.map((benefit: Benefit, index: number) => (
              <div key={index} className="benefit-item mb-[15px] flex w-[235px] flex-col items-center">
                <img src={benefit?.image} alt={'image'} className="h-[330px] w-[250px] pb-15" />
                <div className="px-8 text-center">
                  <p className="pb-15 text-17 font-medium">{benefit?.description}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500">No benefits available.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default ClubHome;
